<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Policy List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Registed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Last Modify
                <b-button size="sm" variant="info" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'updated_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'updated_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_is_alive">Status</label>
              <br>
              <!-- <select v-model="so.opt['is_alive']" @change="refresh">
                <option disabled value="">Please select Status</option>
                <option value='true'>Enable</option>
                <option value='false'>Disable</option>
              </select> -->
              <label for="ph_created_at" v-b-tooltip.hover title="Status">Status</label><br>
              <b-form-group>
                <c-switch color="info" label size="sm" v-model="so.opt['is_alive']" @change="refresh"/>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col md="8">
            <label for="opt_version">Version</label>
            <b-input v-model="so.opt['version']" @keyup.enter="refresh"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="opt_rule">Rule</label>
            <b-input v-model="so.opt['crs_rule']" @keyup.enter="refresh"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            Used : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Not Used : {{model.disable}}
          </b-badge>
        </b-col>

        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='version';so.skt='Version'">Version</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <div>
              <b-button v-if="enable_new !== false" size="sm" variant="success" @click="$router.push({ name: 'webcastle_policy', params: { id : 'add' } })"> New Registration </b-button>
            </div>
          </b-input-group>
        </b-col>

      </b-row>
      <hr>
      <!-- <b-tooltip class="w-100" block target="tooltip-target-1" triggers="hover">
        Category : Categorize of mail
        <br>
        Target : who can get received of mail
        <br>
        Title : title of mail
      </b-tooltip> -->
      <b-table id="tooltip-target-1" triggers="hover" striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <!-- <template slot="is_del" slot-scope="row">
            <b-badge v-if="row.item.is_del" variant="danger">Disable</b-badge>
            <b-badge v-else variant="success">Enable</b-badge>
        </template> -->
        <template slot="is_alive" slot-scope="row">
          <b-badge variant="success" v-if="row.item.is_alive">Enable</b-badge>
          <b-badge v-else variant="secondary">Disable</b-badge>
        </template>
        <template slot="agent_version" slot-scope="row">{{row.item.agent_version || '-' }}</template>
        <!-- <template slot="created_at" slot-scope="row">{{row.item.created_at | date }}</template> -->
        <template slot="updated_at" slot-scope="row">{{row.item.updated_at | datetime }}</template>

        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></partner-List>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import { Api } from '@/service';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, vSelect, cSwitch },
  props : ["auto_refresh", "enable_new", "view_detail"],
  name : "MailList",
  data: () => ({
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', sortable: true, label: 'No.', thStyle: 'width: 5%',},
        // { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: 'Registed_at' },
        { key: 'is_alive', sortable: false, label: 'Status', thStyle: 'width: 10%',},
        { key: 'count', sortable: false, label: 'Count', thStyle: 'width: 10%',},
        { key: 'version', sortable: false, label: 'Version'},
        { key: 'agent_version', sortable: false, label: 'Minimum Agent Version'},
        // { key: 'created_at', sortable: false, label: 'Created_at' },
        { key: 'updated_at', sortable: true, label: 'Last Changed_at' },
        { key: 'func', sortable: false, label: 'More' },
      ]
      // if(this.user) { f.splice(1, 1) }
      return f;
    }
  },
  methods: {
    last_version() {

    },
    setGroup(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['updated_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(['partner_id', 'category_code', 'target_code'].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == false || v == true) { // 컨버팅 필요
        return { name : k, value : v === false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        target : 'webcastle.policy', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_alive':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = this.set_op(k[i], this.so.opt[k[i]].meta.value);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => {
        this.so.totalRows = rs.total;
        console.log("WTF", rs.body)
        return rs.body ? rs.body : [];
      }).catch(e => {
        console.log(e)
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    summary() {
      Api.Manager({ target : 'webcastle.policy', cmd : 'summary', body : { ts : new Date().getTime() } })
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      if(this.view_detail === false) { this.$emit("select", item); }
      else {
        this.$router.push({ name : 'webcastle_policy', params : { id : item.id } });
      }
    },
  },
  created() { console.log('Policy_list.vue', 'created'); },
  destroyed() { console.log('Policy_list.vue', 'destroyed'); },
  mounted() {
    console.log('Policy_list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
